import { Theme, Typography } from '@mui/material'
import _ from 'lodash'

import { UserWorkspaceStatus } from 'features/user/types/userWorkspaceStatus'

export const StatusCell = ({ status }: { status: UserWorkspaceStatus }): React.JSX.Element => (
  <Typography
    sx={(theme: Theme) => ({
      color: status === 'active' ? theme.palette.success.main : theme.palette.warning.main,
    })}
  >
    {_.startCase(status)}
  </Typography>
)
